import type { FC } from 'react';

import Content from './Content';
import Header from './Header';

import { StyledBodyText } from './Typography';

const Loading: FC = () => (
	<>
		<Header />
		<Content>
			<StyledBodyText>Loading...</StyledBodyText>
		</Content>
	</>
);

export default Loading;
